import * as yup from "yup";

const forgotSchema = yup.object({
  email: yup.string().email().required()
}).required();

export default forgotSchema;
